// @ts-nocheck

import * as React from 'react';
import { Link } from '@cloudscape-design/components';

export function getMatchesCountText(count) {
  return count === 1 ? `1 match` : `${count} matches`;
}

// function formatDate(date) {
//   const dateFormatter = new Intl.DateTimeFormat('en-AU', { dateStyle: 'long' });
//   const timeFormatter = new Intl.DateTimeFormat('en-AU', { timeStyle: 'short', hour12: false });
//   return `${dateFormatter.format(date)}, ${timeFormatter.format(date)}`;
// }

function createLabelFunction(columnName) {
  return ({ sorted, descending }) => {
    const sortState = sorted ? `sorted ${descending ? 'descending' : 'ascending'}` : 'not sorted';
    return `${columnName}, ${sortState}.`;
  };
}

export const columnDefinitions = [
    {
      id: "driverId",
      header: "Driver ID",
      cell: item => item.driverId ? item.driverId : "-",
      sortingField: "driverId",
      width: 250,
      ariaLabel: createLabelFunction('Driver ID'),
    },{
      id: "irUserName",
      header: "iRacing Name",
      cell: item => item.irUserName ? item.irUserName : "-",
      sortingField: "irUserName",
      ariaLabel: createLabelFunction('iRacing Name'),
    },{
      id: "irUserId",
      header: "iRacing ID",
      cell: item => item.irUserId ? item.irUserId : "-",
      sortingField: "irUserId",
      width: 130,
      ariaLabel: createLabelFunction('iRacing User ID'),
    },{
      id: "name",
      header: "Name",
      cell: item => item.name ? item.name : "-",
      sortingField: "name",
      ariaLabel: createLabelFunction('Name'),
    },{
      id: "givenName",
      header: "Given Name",
      cell: item => item.givenName ? item.givenName : "-",
      sortingField: "givenName",
      ariaLabel: createLabelFunction('Given Name'),
    },{
      id: "familyName",
      header: "Family Name",
      cell: item => item.familyName ? item.familyName : "-",
      sortingField: "familyName",
      ariaLabel: createLabelFunction('Family Name'),
    },{
      id: "email",
      header: "Email",
      cell: item => item.email ? item.email : "-",
      sortingField: "email",
      ariaLabel: createLabelFunction('Email'),
    },{
      id: "dob",
      header: "Date of birth",
      cell: item => item.hasOwnProperty("dob") ? new Date(item.dob!).toLocaleDateString() : "-",
      sortingField: "dob",
      ariaLabel: createLabelFunction('Date of birth'),
    },{
      id: "address",
      header: "Address",
      cell: item => item.address? item.address : "-",
      sortingField: "address",
      ariaLabel: createLabelFunction('Address'),
    },{
      id: "country",
      header: "Country",
      cell: item => item.country ? item.country : "-",
      sortingField: "country",
      width: 150,
      ariaLabel: createLabelFunction('Country'),
    },{
      id: "discordId",
      header: "Discord ID",
      cell: item => item.discordId ? item.discordId : "-",
      sortingField: "discordId",
      ariaLabel: createLabelFunction('Discord ID'),
    },{
      id: "registrationDate",
      header: "Registration Date",
      cell: item => item.registrationDate ? new Date(item.registrationDate).toLocaleDateString() : "-",
      sortingField: "registrationDate",
      width: 150,
      ariaLabel: createLabelFunction('Registration Date'),
    },
];

export const paginationLabels = {
  nextPageLabel: 'Next page',
  pageLabel: pageNumber => `Go to page ${pageNumber}`,
  previousPageLabel: 'Previous page',
};

const pageSizePreference = {
  title: 'Select page size',
  options: [
    { value: 10, label: '10 resources' },
    { value: 20, label: '20 resources' },
    { value: 50, label: '50 resources' },
    { value: 100, label: '100 resources' },
  ],
};

const visibleContentPreference = {
  title: 'Select visible content',
  options: [
    {
      label: 'Main properties',
      options: columnDefinitions.map(({ id, header }) => ({ id, label: header, editable: id !== 'id' })),
    },
  ],
};
export const collectionPreferencesProps = {
  pageSizePreference,
  visibleContentPreference,
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  title: 'Preferences',
};